import React, { useState, useEffect } from "react";
import "./NotificationMenuStyle.css";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const NotificationMenu = () => {
  const roles = Cookies.get("roles");
  const [isAdmin, setIsAdmin] = useState(false);
  const loginData = Cookies.get("loginData")
    ? JSON.parse(Cookies.get("loginData"))
    : "";
  const location = useLocation();
  const defaultRoute = "/";
  const isDefaultRoute = location.pathname === defaultRoute;

  useEffect(() => {
    if (roles) {
      let tempRole = JSON.parse(roles);
      setIsAdmin(tempRole?.includes("Admin"));
    }
  }, [roles]);

  // Resolve a user-facing display name from any of the common cookie shapes.
  const rawName =
    loginData?.Data?.name ||
    loginData?.name ||
    loginData?.firstName ||
    (loginData?.firstName && loginData?.lastName
      ? `${loginData.firstName} ${loginData.lastName}`
      : "") ||
    loginData?.fullName ||
    loginData?.userName ||
    loginData?.email ||
    "";
  const cleanedName = (typeof rawName === "string" ? rawName : "")
    .trim()
    .split("@")[0];
  const displayName = cleanedName
    ? `${cleanedName.charAt(0).toUpperCase()}${cleanedName.slice(1)}`
    : "";
  const initial = displayName ? displayName.charAt(0).toUpperCase() : "U";

  return (
    <>
      <div className="notificationWrap">
        <div className="welcomeText">
          <span className="userAvatar" aria-hidden="true">
            {initial}
          </span>
          <span className="welcomeTextLabel">
            Welcome{displayName ? `, ${displayName}` : ""}!
          </span>
        </div>

        {isDefaultRoute && isAdmin && <div />}
      </div>
    </>
  );
};

export default NotificationMenu;
